import React, { ChangeEvent, useEffect, useState } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { track } from 'apis/amethyst';
import { evSephoraBeautyInsider, SephoraInteraction } from 'events/sephora';
import { isValidVerificationCode } from 'helpers/index';
import { linkSephoraAccount, receiveSephoraLoyalty, validateSephoraAccount } from 'actions/sephora';
import useSephoraContext from 'hooks/useSephoraContext';
import { selectIsLoadingLoyalty, selectIsValidated, selectLoyaltyError } from 'selectors/sephora';
import { SmallLoader } from 'components/Loader';

import css from 'styles/components/sephora/beautyInsiderVerifyEmailForm.scss';

const BeautyInsiderVerifyEmailForm = () => {
  const [verificationCode, setVerificationCode] = useState('');
  const { sephoraEmail, setView } = useSephoraContext();
  const isLoading = useSelector(selectIsLoadingLoyalty);
  const isValidated = useSelector(selectIsValidated);
  const verificationError = useSelector(selectLoyaltyError);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!sephoraEmail) {
      dispatch(receiveSephoraLoyalty({}));
      setView('accountInfo');
    }

    if (isValidated) {
      setView('accountInfo');
    }
  }, [sephoraEmail, isValidated]);

  const handleResendCode = () => {
    track(() => [evSephoraBeautyInsider, { interaction: SephoraInteraction.RESEND_CODE_BUTTON_CLICK }]);
    dispatch(linkSephoraAccount(sephoraEmail));
  };

  const handleConnectClick = () => {
    dispatch(validateSephoraAccount(sephoraEmail, verificationCode));
  };

  return isLoading ? (
    <SmallLoader />
  ) : (
    <>
      <div className={cn(css.formField, { [css.fieldError]: verificationError })}>
        <label htmlFor="sephoraEmail">Verification Code</label>
        <input
          autoComplete="off"
          type="text"
          name="sephoraVerificationCode"
          value={verificationCode}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.target.value)}
          placeholder="Enter 6 Digit Code"
        />
        {verificationError && <div className={css.errorText}>{verificationError}</div>}
      </div>
      <p className={css.noCode}>
        Didn't receive a code?&nbsp;
        <button className={css.linkButton} type="button" onClick={handleResendCode}>
          Resend code
        </button>
      </p>
      <button className={css.button} type="button" disabled={!isValidVerificationCode(verificationCode)} onClick={handleConnectClick}>
        Connect
      </button>
      <div className={css.acknowledgment}>
        By clicking on Continue, you acknowledge and agree that Zappos.com LLC may send your relevant purchase information and the email address you
        provided to Sephora.
      </div>
    </>
  );
};

export default BeautyInsiderVerifyEmailForm;
